import React from "react";
import "../Styles/Capabilities.css";
import "../Styles/ContactSection.css";
import capabilities_1 from "../Images/cap.jpeg";
import Footer from "./Footer";

const equipmentCategories = [
  {
    title: "CNC MACHINES",
    items: [
      "Mori Seiki Turning Center CL25B 3.5\" thru hole",
      "Okuma MX-45VAE, 20 Tool ATC, 30\" travels w/ twin 5c rotary",
      "Omax Waterjet 55100 50,000psi — 5' x 10' table",
      "CAD/CAM: Solidworks and GibbsCAM",
    ]
  },
  {
    title: "TOOLING / INSPECTION",
    items: [
      "Mitutoyo CMM with CMM manager software",
      "Doall grade AA granite surface plates",
      "Etalon Bore gages to 6″ .0001″ resolution",
      "24\" Starrett digital height gauge",
      "Thread mics up to 4″, digital calipers to 60″",
      "Mitutoyo digital depth gauges – .00002″ resolution",
      "Wilson Rockwell Hardness Tester",
      "Nikon Optical Comparator",
    ]
  },
  {
    title: "WELDING",
    items: [
      "Panasonic 500 amp AC/DC TIG",
      "Miller Maxstar 140 portable TIG",
      "Lincoln Power MIG 255",
      "Victor oxy/acetylene rig",
      "Nelson TRW stud welder",
    ]
  },
  {
    title: "MANUAL MACHINES",
    items: [
      "Monarch 10EE tool room lathe, 5C collet closer, DRO",
      "Mori Seiki MS-1850 lathe, Buck 6 jaw, DRO",
      "Bridgeport vertical mill, variable speed, DRO",
      "Cincinnati horizontal #2 mill w/ vertical head",
      "Taft Pierce surface grinder",
      "Di-Acro 36\" hydraulic brake",
      "DoAll vertical band saw w/ blade welder",
      "Marvel vertical tilting cutoff bandsaw",
    ]
  },
  {
    title: "SUPPORT EQUIPMENT",
    items: [
      "2 ton Fork lift",
      "5000# bridge crane",
      "Atlas Copco Rotary Screw compressor",
      "800 lb. torque wrench w/ skidmore tester",
      "Rotary deburring tumbler",
      "Ultrasonic cleaner",
    ]
  },
];

function ContactSection() {
  return (
    <div className="contact-us">
      <div className="contact-us-inner">
        <div className="contact-us-left">
          <p className="contact-us-eyebrow">Get In Touch</p>
          <h2 className="contact-us-heading">Let's build something<br />precise together.</h2>
          <div className="contact-us-items">
            <div className="contact-us-item">
              <span className="contact-us-icon">📍</span>
              <div>
                <span className="contact-us-label">Address</span>
                <span className="contact-us-value">6240 Hawthorne Drive, Windsor, ON N8T 1J9, Canada</span>
              </div>
            </div>
            <div className="contact-us-item">
              <span className="contact-us-icon">📞</span>
              <div>
                <span className="contact-us-label">Phone</span>
                <span className="contact-us-value">+1 519 800-8080</span>
              </div>
            </div>
            <div className="contact-us-item">
              <span className="contact-us-icon">✉️</span>
              <div>
                <span className="contact-us-label">Email</span>
                <a href="mailto:info@precisionworks.ca" className="contact-us-value contact-us-link">info@precisionworks.ca</a>
              </div>
            </div>
          </div>
          <a href="/contact" className="contact-us-cta">Send Us a Message</a>
        </div>
        <div className="contact-us-map">
          <iframe
            title="Google Maps Locator"
            src="https://maps.google.com/maps?width=100%25&height=600&hl=en&q=6240+Hawthorne+Dr,+Windsor,+ON+N8T+1J9,+Canada&t=&z=16&ie=UTF8&iwloc=B&output=embed"
            style={{ width: "100%", height: "100%", border: 0, display: "block" }}
          ></iframe>
        </div>
      </div>
    </div>
  );
}

function Capabilities() {
  return (
    <div className="capabilities-page">
      <div className="page-hero">
        <h1>CAPABILITIES</h1>
        <div className="section-divider"></div>
      </div>

      <div className="capabilities-overview">
        <div className="capabilities-list-card">
          <h2>What We Offer</h2>
          <ul>
            <li>Prototyping and Production</li>
            <li>Contract Manufacturing</li>
            <li>Product Development</li>
            <li>CNC Mill and Lathe</li>
            <li>Abrasive Waterjet Cutting 5 x 10</li>
            <li>2D / 3D CAD / CAM</li>
            <li>Conventional Machining</li>
            <li>Full CMM Inspection</li>
            <li>TIG &amp; MIG Welding</li>
            <li>2.5-ton crane and 2-ton forklift</li>
          </ul>
        </div>
        <div className="capabilities-image-card">
          <img src={capabilities_1} alt="CNC Machine" />
        </div>
      </div>

      <div className="equipment-section">
        <div className="equipment-section-inner">
          <h2>TOOLS &amp; EQUIPMENT</h2>
          <div className="section-divider"></div>
          <div className="equipment-grid">
            {equipmentCategories.map((cat) => (
              <div className="equipment-card" key={cat.title}>
                <h3>{cat.title}</h3>
                <ul>{cat.items.map((item, i) => <li key={i}>{item}</li>)}</ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <ContactSection />
      <Footer />
    </div>
  );
}

export default Capabilities;
